export function getWebsiteIdFromPath() {
    return window.location.pathname.split('/')[1];
}
